/* eslint-disable */
import debounce from 'extensions/debounce/debounce';
import { getParent } from 'extensions/selector/selector';

export default class ProductSwatches {

	defaultOptions = {
		productCardElement: 'js-product-card'
	};

	constructor( options ) {

		if ( options && ( options.productCardElement == null || (typeof options.productCardElement !== 'string') ) ) {
			throw new Error( '[ProductSwatches].constructor - Invalid type for option `productCardElement`. Must be a selector string.' );
		}
		
		this.options = options && options.length > 0 ? options : this.defaultOptions;

		this.cardElements =  {
			productCardImageElement: '.js-product-card__image',
			productCardAnchorElement: '.js-product-card__link',
			swatchContainer: '.js-product-swatches',
			swatchElement: 'js-product-card__swatch',
			swatchCountElement: '.js-product-swatches__count',
			swatchMoreElement: '.js-product-swatches__more'
		}

		this.cards = document.getElementsByClassName( this.options.productCardElement );
	
		if ( this.cards ) {
			this.bindEvents();
			this.updateSwatchCount( this.cards );
		}
		
	}
	
	updateCardImage( swatch, card ) {
	
		const swatchImage = swatch.getAttribute( 'data-variant-image' );
		
		// set image source from currently active swatch element
		if ( swatchImage ) {
			const cardImageElement = card.querySelector( this.cardElements.productCardImageElement);
			cardImageElement.src = swatchImage;
		}
		
	}

	updateCardLink( swatch, card ) {
		const cardAnchorElement = card.querySelector( this.cardElements.productCardAnchorElement );

		// set master product url to add variant ID to url if found
		if ( cardAnchorElement && cardAnchorElement.tagName === 'A' ) {
			let swatchUrl = new URL( cardAnchorElement.href );
			let swatchParams = new URLSearchParams( swatchUrl.search.slice( 1 ) );
			let swatchId = parseInt( swatch.getAttribute( 'data-variant-id' ) );

			if (typeof swatchId === 'number') {
				swatchParams.set( 'variant_id', swatchId );
				swatchUrl.search = swatchParams.toString();
				cardAnchorElement.href = swatchUrl.toString();
			}
		}
	}

	updateActiveSwatch( element, swatches) {
		// remove active class from all swatches
		for ( const swatch of swatches ) {
			if ( swatch.classList.contains( 'active' ) ) {
				swatch.classList.remove( 'active' );
			}
		}

		element.classList.add( 'active' );
	}

	updateSwatchCount( cards ) {

		for (const card of cards) {
		
			let swatchCountElement = card.querySelector( this.cardElements.swatchCountElement );
			let swatchCountMore =  card.querySelector( this.cardElements.swatchMoreElement );
			let swatches = card.getElementsByClassName( this.cardElements.swatchElement );
			let hiddenCount = 0;
		
			if ( swatches && swatches.length > 0 ) {

				for ( let swatch of swatches ) {
			
					if ( swatch.offsetHeight === 0 && swatch.offsetWidth === 0 ) {
						hiddenCount++;
					}		
			
				}
			
				if ( hiddenCount > 0 && swatchCountElement) {
					swatchCountElement.innerHTML = ' +' + hiddenCount;
					swatchCountMore.innerHTML = ' more';
				} 

			}

		}

	}

	bindEvents() {

		// resize event
		window.addEventListener( 'resize', debounce( 66, e => this.onSwatchResize() ), false );

		// click event
		for (const card of this.cards) {

			const swatches = card.getElementsByClassName( this.cardElements.swatchElement );

			if ( swatches && swatches.length > 0 ) {

				for (const swatch of swatches) {
					swatch.addEventListener( 'click', e => this.onSwatchClick( e, card, swatches ), false );
				}

			}

		}

	}

	onSwatchResize() {

		// update swatch count display
		this.updateSwatchCount( this.cards );

	}

	onSwatchClick( e, card, swatches ) {
	
		e.preventDefault();

		const swatch = getParent(e.srcElement, '.js-product-card__swatch');

		if ( swatch ) {
			// update product card link
			this.updateCardLink( swatch, card );

			// update active class
			this.updateActiveSwatch( swatch, swatches );

			// swap image
			this.updateCardImage( swatch, card );
		}
	
	}

};